import React from 'react';
import LogoIcon from '../common/Logo/LogoIcon/LogoIcon';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import colors from 'src/utils/colors';
import { getAppName } from 'src/utils/app';

interface LogoContainerProps {
  title: string;
}

const logoSize = '48px';
const brandclubLogoWidth = '72px';
const brandclubLogoHeight = '11px';

export default function LogoContainer({ title }: LogoContainerProps) {
  const isBrandclubOS = getAppName() === 'BrandclubOS';
  const logoWidth = isBrandclubOS ? brandclubLogoWidth : logoSize;
  const logoHeight = isBrandclubOS ? brandclubLogoHeight : logoSize;

  return (
    <Flex flexDirection="column" alignItems="center">
      <Flex justifyContent="center">
        <div
          style={{
            width: logoWidth,
            height: logoHeight,
            maxHeight: logoHeight,
            maxWidth: logoWidth,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <LogoIcon
            height={logoHeight}
            width={logoWidth}
            style={{ width: logoWidth, height: logoHeight, maxWidth: '100%', maxHeight: '100%' }}
          />
        </div>
      </Flex>
      <Text
        variant="h4"
        textAlign="center"
        transform="uppercase"
        fontWeight={600}
        sx={{
          fontFamily: "'Geist'",
          fontSize: '26px',
          marginTop: '8px',
          letterSpacing: '2.5px',
          color: colors.darkBlue
        }}
      >
        {title}
      </Text>
    </Flex>
  );
}
